import dompurify from 'dompurify';
import { FC } from 'react';

import { PolicyContentData } from './interface';

import { DSAccordion } from '../../../designSystem/DSAccordion';
import './styles.scss';

interface Props {
	policyData: PolicyContentData;
}

const PolicyContent: FC<Props> = ({ policyData }) => {
	if (!policyData?.title && !policyData?.description) {
		return <></>;
	}

	return (
		<div className="my-2" data-cy="seo-description">
			<DSAccordion title={policyData.title} titleTag="h1">
				<div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(policyData.description) }} />
			</DSAccordion>
		</div>
	);
};

export default PolicyContent;
